var map = {
	"./0000FF.png": "25fa",
	"./008000.png": "b25b",
	"./008080.png": "71f7",
	"./00BFFF.png": "3fd3",
	"./00CED1.png": "b184",
	"./483D8B.png": "5a44",
	"./4B0082.png": "f242",
	"./66CDAA.png": "6fb9",
	"./7FFF00.png": "48e7",
	"./808000.png": "8961",
	"./9400D3.png": "c210",
	"./C71585.png": "7aeb",
	"./DEFF1C.png": "34d8",
	"./FF0000.png": "e59e",
	"./FF00FF.png": "20d6e",
	"./FF1493.png": "50b4",
	"./FF974C.png": "715c",
	"./FFA500.png": "153e",
	"./FFB6C1.png": "ea91",
	"./FFC915.png": "c460",
	"./FFD700.png": "8607",
	"./FFFFFF.png": "1f0d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b05d";